import React from "react";
import './events.css';
import Img1 from '../Images/rdfs11.png';
import Img2 from '../Images/rdfs12.png';
import Img3 from '../Images/rdfs10.jpg';
import Img4 from '../Images/sonyfx9_2.jpg';
import Img5 from '../Images/drone.jpg';
import Img6 from '../Images/tree.jpg';
import Img7 from '../Images/sonyfx6.jpg';
import Img8 from '../Images/sonyfx9.jpg';
import Img9 from '../Images/sonyfx30.jpg';
// import Pract from "./Pract";
// import Users from './Users';

const Gallery = ()=>{


    return(
        <>
        <div id="gallery-container">
           <div className='section-title'>Gallery</div> 
              <div className="gallery-div">
                   <div className="gallery-sub-div">
                        <div className="gallery-sub-div-la"><img src={Img3} alt="img-3"/></div>
                        <div className="gallery-sub-div-la"><img src={Img1} alt="img-1"/></div>                               
                    </div>
                    <div className=".gallery-sub-div-sm">
                        <img src={Img9} alt="img-6"/>    
                    </div>
                   <div className="gallery-sub-div">
                        <div className="gallery-sub-div-la"><img src={Img5} alt="img-3"/></div>
                        <div className="gallery-sub-div-la"><img src={Img4} alt="img-1"/></div>                               
                    </div>                 
              </div> 
           </div>
        </>
    );
}

export default Gallery;